import type { ScheduleTemplateOut } from "@/pages/human-resources/time-management/endpoints/schedules/templates/inout/ScheduleTemplateOut.ts";
import axios from "axios";
import type { ScheduleTemplateIn } from "@/pages/human-resources/time-management/endpoints/schedules/templates/inout/ScheduleTemplateIn.ts";

export async function getDomainScheduleTemplates(
  domainId: string,
): Promise<ScheduleTemplateOut[]> {
  const { data } = await axios.get<ScheduleTemplateOut[]>(
    `/api/planning/templates/domains/${domainId}`,
  );
  return data;
}

export async function getSiteScheduleTemplates(
  domainId: string,
  siteId: string,
): Promise<ScheduleTemplateOut[]> {
  const { data } = await axios.get<ScheduleTemplateOut[]>(
    `/api/planning/templates/domains/${domainId}/sites/${siteId}`,
  );
  return data;
}

export async function createSiteScheduleTemplate(
  domainId: string,
  siteId: string,
  template: ScheduleTemplateIn,
): Promise<void> {
  await axios.post(
    `/api/planning/templates/domains/${domainId}/sites/${siteId}`,
    template,
  );
}
